define(function (require) {
	//this file is not technically a collection but an aggregator of collections.
	const addresses = require('./nearest_address_collection');
	const parcels = require('./nearest_parcel_collection');
	const assets = require('./nearest_asset_collection');

	const mapUtils = require('civicsUtils/map_utilities');

	const address = 'address';
	const parcel = 'parcel';
	const asset = 'asset';
	const property = 'property';

	return function () {
		return {
			fetchClosestIndividualSite: function (siteTypes, point, extentSize) {
				//can't do anything without siteTypes and a point.
				if (siteTypes == null || point == null || extentSize == null) return null;
				let fetchPromise = $.Deferred();
				$.when(this.fetchClosestSites(siteTypes, point, extentSize)).done((sites) => {
					if (sites && sites.length > 0) {
						fetchPromise.resolve(sites[0]);
					} else {//no sites in extent
						fetchPromise.resolve(null);
					}
				})
				return fetchPromise;
			},
			fetchClosestSites: function (siteTypes, point, extentSize, maxSitesCount, getCenterPoint = true) {
				//can't do anything without siteTypes and a point.
				if (siteTypes == null || point == null || extentSize == null) return null;
				let extent = mapUtils.buildExtentFromPoint(point.x, point.y, extentSize);
			    let collections = this.buildCollections(point, siteTypes, extent, maxSitesCount, getCenterPoint);
				return this.fetch(collections, point, maxSitesCount);
			},
			fetch: function (collections, point, maxSitesCount) {
				let fetchPromise = $.Deferred();
				let promiseArray = [];
				collections.forEach(col => {
					promiseArray.push(col.fetch());
				});
				$.when(...promiseArray).done(() => {
					//we want to combine the sorted sites 
					let combinedSites = this.combineCollections(collections, maxSitesCount);
					let currentIndex = 1;
					//let filteredSites = combinedSites.filter((item) => { return item.Spatial != undefined });
					//we want to group the collection and sort per group
					//let sortedSites = this.sortSitesByDistance(filteredSites, point);
					//let groupedSites = this.sortGroupCollection(filteredSites, point);
					//sort array by site type
					function customComparator(a, b) {
						var order = {
							address: 1,
							parcel: 2,
							asset: 3,
							property: 4
						};
					
						var orderA = order[a._siteType] || 0;
						var orderB = order[b._siteType] || 0;
					
						return orderA - orderB;
					}
					combinedSites.sort(customComparator);
					//setting the site index after sorting
					combinedSites.forEach(function(item) {
						item._siteIndex = currentIndex++;
					},{silent:true});
		
					fetchPromise.resolve(combinedSites);
				}).fail(function(response, status, xhrResponse) {
					fetchPromise.resolve();
				});
				return fetchPromise;
			},


			buildCollections(point, siteTypes, extent, maxSitesCount, getCenterPoint) {
				let collection = []
				siteTypes.forEach(type => {
					let col = null;
					const { ipsComponentType: site, assetType: assetType } = type;
					let siteType = site ? site.toLowerCase() : '';
					if (siteType.includes(address)) {
						col = new addresses();
					} else if (siteType.includes(parcel)) {
						col = new parcels();
						col.maxSitesCount = maxSitesCount;
						col.tryCenterPoint = getCenterPoint;
					} else if (siteType.includes(asset)) {
						if (assetType != null) {
							col = new assets();
							col.assetType = assetType;
						}
					} else if (siteType.includes(property)) {
						//implement at later date
					}

					if (col != null) {
						//don't sort the individual results. We will sort them once we've combined them.
						col.skipSort = false;
						col.extent = extent;
						col.point = point;
						collection.push(col);
					}
				});
				return collection;
			},

			combineCollections: function (collections, maxCount) {
				let count = maxCount ? maxCount : 5;
				let sites = [];
				
				collections.forEach(col => {
					let filteredCol = this.removeDuplicates(col);
					if (filteredCol.models.length > 0){
						sites.push(...filteredCol.toJSON().slice(0,count));
					}
				});
				return sites;
			},
			
			removeDuplicates:function(collection){
				let filtered = new Backbone.Collection();
				let index = 1;
				if(this.selectedSitesCollection && this.selectedSitesCollection.length>0){

					collection.forEach((site) =>{
						let siteSelected = this.selectedSitesCollection.findWhere({
							_siteType:site.get('_siteType'),
							id:site.get('id')
						});
						//site selected will be undefined if no site was found that matches
						if(!siteSelected){
							//site._siteIndex = index++;
							filtered.add(site);
						}
					});
					return filtered;
					
				}
				return collection;
				
			},	
			sortSitesByDistance: function (sites, point) {
				sites = mapUtils.sortSitesByDistance(point, sites);
				return sites;
			}
		}
	}
});
